import React from 'react';
import ReaderWrapper from '../ReaderWrapper';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    header: {
        fontWeight: '600',
    },
    downloadLink: {
        fontWeight: '500',
    },
};

class InfoReader extends React.Component {
    constructor() {
        super();
        this.state = {
            dataExe: ['Loading...'],
            updateExe: ['Loading...'],
            dataMsi: ['Loading...'],
            updateMsi: ['Loading...'],
        };
    }

    componentDidMount() {
        const FlightReader = this;
        fetch('https://updates.signiant.com/signiant_app/signiant-app-info.json')
            .then(async (response) => {
                const modifiedSince = response.headers.get('last-modified');

                return { data: await response.json(), modifiedSince };
            })
            .then(({ data, modifiedSince }) => {
                this.setState({
                    dataExe: data['signiant-app']['windows'].version.substring(0, 8),
                    updateExe: data['signiant-app']['windows'].file,
                    date: modifiedSince.substring(5, 16),
                    dataMsi: data['signiant-app']['windowsmsi'].version.substring(0, 8),
                    updateMsi: data['signiant-app']['windowsmsi'].file,
                });
            });

        const FlightReaderMac = this;
        fetch('https://updates.signiant.com/signiant_app/signiant-app-info-mac.json')
            .then(async (response) => {
                const modifiedSinceMac = response.headers.get('last-modified');

                return { data: await response.json(), modifiedSinceMac };
            })
            .then(({ data, modifiedSinceMac }) => {
                //console.log(modifiedSince);

                this.setState({
                    dataDmg: data['signiant-app']['osx'].version.substring(0, 8),
                    updateDmg: data['signiant-app']['osx'].file,
                    dateMac: modifiedSinceMac.substring(5, 16),
                });
            });
    }

    render() {
        const { classes } = this.props;
        return (
            <ReaderWrapper>
                <table>
                    <thead className={classes.header}>
                        <td>Installer Type</td>
                        <td>Version</td>
                        <td>Release Date</td>
                        <td></td>
                    </thead>
                    <tr>
                        <td>Windows .exe</td>
                        <td>{this.state.dataExe}</td>
                        <td>{this.state.date}</td>
                        <td>
                            <a
                                id="download-signiant-app-windows-exe"
                                className={classes.downloadLink}
                                href={'https://updates.signiant.com/signiant_app/' + this.state.updateExe}
                            >
                                Download
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>Windows .msi</td>
                        <td>{this.state.dataMsi}</td>
                        <td>{this.state.date}</td>
                        <td>
                            <a
                                id="download-signiant-app-windows-msi"
                                className={classes.downloadLink}
                                href={'https://updates.signiant.com/signiant_app/' + this.state.updateMsi}
                            >
                                Download
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>macOS .dmg</td>
                        <td>{this.state.dataDmg}</td>
                        <td>{this.state.dateMac}</td>
                        <td>
                            <a
                                id="download-signiant-app-mac-dmg"
                                className={classes.downloadLink}
                                href={'https://updates.signiant.com/signiant_app/' + this.state.updateDmg}
                            >
                                Download
                            </a>
                        </td>
                    </tr>
                </table>
            </ReaderWrapper>
        );
    }
}

export default withStyles(styles)(InfoReader);
